import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScwMatButtonSize, ScwMatButtonType } from './scw-mat-button.model';

@Component({
  selector: 'scw-mat-button',
  templateUrl: './scw-mat-button.component.html',
  styleUrls: ['./scw-mat-button.component.scss'],
})
export class ScwMatButtonComponent implements OnInit {
  @Input() type: ScwMatButtonType = 'cta';
  @Input() size: ScwMatButtonSize = 'md';
  @Input() submit: boolean = false;
  @Input() block: boolean = false;
  @Input() iconButton: boolean = false;
  @Input() fab: boolean = false;
  @Input() disabled: boolean = false;
  @Input() className:
    | string[]
    | {
        [klass: string]: any;
      };
  @Input() form: string;
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  public onClickEmitterForScwMatForm(): void {}

  public onClickEmitter(): void {
    this.onClick.emit();
    this.onClickEmitterForScwMatForm();
  }

  public ngOnInit(): void {}
}
